import { useState } from "react";
import { MenuButton } from "@narmi/design_system";
import { useUserConfiguration } from "../../hooks/useUserConfiguration.ts";
import styles from "./Navigation.module.css";
import { useInstitutionContext } from "@hooks/institutionContext";

export function UserSettingsMenu() {
  const { features } = useUserConfiguration();
  return (
    <MenuButton trigger={<Avatar />} label="Avatar">
      {/* <MenuButton.Item
        label="Change password"
        onSelect={function noRefCheck() {}}
      /> */}
      {features.includes("staff_portal_password_login") && (
        <MenuButton.Item
          label="Security"
          onSelect={() => {
            window.location.href = "/security";
          }}
        />
      )}
      {/* <MenuButton.Item
        label="Forget this device"
        onSelect={function noRefCheck() {}}
      /> */}
      <MenuButton.Item
        label="Log out"
        onSelect={() => {
          window.location.href = "/logout";
          // clear session storage when a user logs out
          sessionStorage.clear();
        }}
      />
    </MenuButton>
  );
}

function Avatar() {
  const [hasError, setHasError] = useState(false);
  const { currentUser, roles } = useUserConfiguration();
  const {
    institution: { fi_staff_oauth_providers },
  } = useInstitutionContext();
  const shouldFetchAvatar =
    // todo: find better way to check if staff is using oauth
    roles.narmi || (Array.isArray(fi_staff_oauth_providers) && fi_staff_oauth_providers.length > 0);

  const avatarUrl = `/users/${currentUser.id}/avatar`;
  let avatar;

  if (hasError || !currentUser.id || !shouldFetchAvatar) {
    avatar = <span className="narmi-icon-user" />;
  } else {
    avatar = <img src={avatarUrl} onError={() => setHasError(true)} />;
  }
  return (
    <div className={styles.avatar} data-testid="avatar">
      {avatar}
    </div>
  );
}
